import { Component } from '@angular/core';

/**
 * To wait auth loading if the page is called on server side.
 * @see src/app/auth/guards/auth.guard.ts
 */
@Component({
  selector: 'app-auth-waiting',
  templateUrl: './waiting.component.html',
})
export class AuthPageWaitingComponent {}
